import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode"; // 記得 npm install jwt-decode
import { tokenManager } from '../../contexts/AuthContext';
import { ssmsLogin } from '../../services/api'; // 使用 api.js 的 login function

const SsmsLoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
            // 設定這一頁專屬的 Browser Tab 標題
            document.title = "更表管理 | Kaka卡卡兒童超跑"; 

            // (Optional) Cleanup: 當離開呢頁時，改返做預設標題
            return () => {
                document.title = "Kaka卡卡兒童超跑";
            };
        }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        

        try {

            const response = await ssmsLogin(username, password);
            const data = response.data;

            console.log("Login Response:", data); // Debug: 睇下到底係 access 定 access_token
            // data 應該包含 { access: "...", refresh: "..." }
            
            // 2. 關鍵修正：Mapping
            // SimpleJWT 回傳 'access'，但 tokenManager 可能慣用舊名，
            // 所以我們這裡做一個轉換，確保捉到值。
            const accessToken = data.access || data.access_token;
            const refreshToken = data.refresh || data.refresh_token;
            
            if (!accessToken) {
                throw new Error("Login 成功但找不到 Token，請檢查 Console Log");
            }

            tokenManager.setTokens(accessToken, refreshToken, 'staff');

            const decoded = jwtDecode(data.access);
            // 可以在 Console 看到 role, chiname 等
            console.log("User Info:", decoded);

            //保齊 userData, 防止唔夾舊 logic 而被登出
            // 3. 👇👇👇 新增：構建並儲存 User Data 👇👇👇
            // AuthContext 依賴這個來通過 F5 檢查
            const userData = {
                id: decoded.user_id || decoded.id,
                username: decoded.chiname || username, // 用中文名或帳號做顯示名稱
                role: decoded.role,
                merchantId: decoded.merchant_id
            };

            // 存入 localStorage ('auth_user')
            // 第二個參數 membership 暫時俾 null，因為員工不需要會員籍
            tokenManager.setUserData(userData, null);

            // 👇👇👇 新增這段 Redirect Back Logic 👇👇👇
            const redirectPath = sessionStorage.getItem('auth_redirect');
            if (redirectPath && redirectPath.startsWith('/ssms')) {
                // 如果有存檔路徑，而且是 SSMS 內的路徑，就跳回去
                sessionStorage.removeItem('auth_redirect'); // 用完即棄
                navigate(redirectPath);
            } else {
                // 否則走預設路徑
                if (decoded.role === 'MANAGER') {
                    navigate('/ssms/manager/dashboard');
                } else if (decoded.role === 'EMPLOYEE') {
                    navigate('/ssms/staff/dashboard');
                } else {
                    setError('未知的身份角色');
                }
            }

        } catch (err) {
        console.error("Login Error:", err);

        // 👇👇👇 重點在這裡 👇👇👇
        if (err.response && err.response.status === 401) {
            // 專門捉 401 (Unauthorized)
            setError('帳號或密碼錯誤，請檢查後再試。'); 
        } else if (err.response && err.response.status === 500) {
            // 捉 500 (Server Error)
            setError('伺服器繁忙，請稍後再試。');
        } else if (err.code === "ERR_NETWORK") {
            // 捉網絡問題 (例如 backend 死左)
            setError('無法連接伺服器，請檢查網絡。');
        } else {
            // 其他未知的錯
            setError('登入發生錯誤，請聯絡管理員。');
        }
        // 👆👆👆 End 👆👆👆
    } finally {
        setLoading(false);
    }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>SSMS 員工系統登入</h2>
                <form onSubmit={handleLogin}>
                    <div style={styles.inputGroup}>
                        <label>帳號 (Phone Number)</label>
                        <input 
                            type="text" 
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={styles.input}
                            disabled={loading}
                            required
                        />
                    </div>
                    <div style={styles.inputGroup}>
                        <label>密碼 (Password)</label>
                        <input 
                            type="password" 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={styles.input}
                            disabled={loading}
                            required
                        />
                    </div>
                    {error && <p style={styles.error}>{error}</p>}
            <button
            type="submit"
            disabled={loading} // 鎖死按鈕
            className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white 
              ${loading 
                ? 'bg-indigo-400 cursor-not-allowed' // Loading 時變淺色 + 禁止鼠標
                : 'bg-indigo-600 hover:bg-indigo-700 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              } transition duration-150 ease-in-out`}
          >
            {loading ? (
              // 7. 加個簡單的 Spinner 或者轉文字
              <span className="flex items-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                登入中...
              </span>
            ) : (
              '登入'
            )}
          </button>
                </form>
            </div>
        </div>
    );
};

// 簡單的 CSS Styles，你可以之後再改用 class 或 styled-components
const styles = {
    container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f2f5' },
    card: { padding: '2rem', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', width: '300px' },
    title: { textAlign: 'center', marginBottom: '1.5rem', color: '#333' },
    inputGroup: { marginBottom: '1rem' },
    input: { width: '100%', padding: '8px', marginTop: '5px', borderRadius: '4px', border: '1px solid #ddd', boxSizing: 'border-box' },
    button: { width: '100%', padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' },
    error: { color: 'red', fontSize: '14px', marginBottom: '10px' }
};

export default SsmsLoginPage;